import { render, staticRenderFns } from "./ClientObservations.vue?vue&type=template&id=59346907&"
import script from "./ClientObservations.vue?vue&type=script&lang=js&"
export * from "./ClientObservations.vue?vue&type=script&lang=js&"
import style0 from "./ClientObservations.vue?vue&type=style&index=0&id=59346907&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports